import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {

  async getValidarAcessoRecurso(hospitalId: string, medicoId: string, resourceName: string, cods?: string[]) {
    if (cods && cods.length > 0) {
      const params = new URLSearchParams()
      cods.forEach(c => params.append('codTuss', c))
      const res = await api.get(`recurso-hospitalar/${hospitalId}/medico/${medicoId}/recurso/${resourceName}?${params.toString()}`)
      return factory.build(res)
    }
    const res = await api.get(`recurso-hospitalar/${hospitalId}/medico/${medicoId}/recurso/${resourceName}`)
    return factory.build(res)
  },

}
